import { inject, injectable } from 'inversify';
import { action, computed, makeObservable } from 'mobx';
import type { IImageSliceViewModel } from '@/engine/app/interfaces';

import type { ViewsService } from '@/engine/app/Views.service';
import type { SliceType } from '@/engine/app/modules/images/interfaces';
import { TYPES } from '@/engine/ioc';

@injectable()
export class ImageSlicesListController {
  private readonly _viewsService: ViewsService;

  public constructor(@inject(TYPES.ViewsService) viewsService: ViewsService) {
    this._viewsService = viewsService;
    makeObservable(this);
  }

  @computed
  public get imageSlices(): Array<IImageSliceViewModel> | undefined {
    return this._viewsService.currentView?.getImageSlices();
  }

  @action
  public toggleImageSliceVisibility(imageSlice: IImageSliceViewModel): void {
    imageSlice.setVisibility(!imageSlice.isVisible);
  }

  @action
  public toggleImageSliceVisibilityByType(sliceType: SliceType): void {
    if (!this.imageSlices) {
      return;
    }

    const currentImageSlice = this.imageSlices.find((imageSlice) => imageSlice.descriptor === sliceType);

    if (!currentImageSlice) {
      return;
    }

    currentImageSlice.setVisibility(!currentImageSlice.isVisible);
  }

  public getImageSliceByType(sliceType: SliceType): IImageSliceViewModel | undefined {
    if (!this.imageSlices) {
      return;
    }

    const currentImageSlice = this.imageSlices.find((imageSlice) => imageSlice.descriptor === sliceType);

    return currentImageSlice;
  }
}
